// import React, { useState, useEffect, useCallback } from "react"; // Add useCallback
// import {
//   Container,
//   Typography,
//   Box,
//   Button,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormControl,
//   FormLabel,
//   Card,
//   CardContent,
//   CircularProgress,
// } from "@mui/material";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import { Timer as TimerIcon } from "@mui/icons-material";

// const Quiz = () => {
//   const [quiz, setQuiz] = useState(null);
//   const [answers, setAnswers] = useState({});
//   const [timeLeft, setTimeLeft] = useState(0);
//   const [submitted, setSubmitted] = useState(false);
//   const [score, setScore] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [noQuiz, setNoQuiz] = useState(false); // ✅ new state

//   const navigate = useNavigate();

//   const student = localStorage.getItem("token");
//   const decoded = jwtDecode(student);
//   console.log(decoded);

//   // Fetch quiz data from backend on mount
//   useEffect(() => {
//     // const token = localStorage.getItem("token");

//     // Assuming you store user object in localStorage after login

//     const department = decoded.user.department;
//     const subjects = decoded.user.subjects || [];

//     if (!department || subjects.length === 0) {
//       console.error("Missing department or subjects for student");
//       return;
//     }
//     const fetchQuiz = async () => {
//       setLoading(true);
//       setNoQuiz(false); // reset on each fetch

//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/api/quiz`,
//           {
//             params: {
//               department,
//               subjects: subjects, // send first subject or selected subject
//             },
//           }
//         );

//         console.log("Fetched quiz:", response.data);
//         setQuiz(response.data);
//         setTimeLeft(response.data.duration);
//       } catch (error) {
//         console.error("Error fetching quiz:", error);
//         if (error.response && error.response.status === 404) {
//           setNoQuiz(true); // ✅ No quiz found
//         }
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchQuiz();
//   }, []);

//   // Memoize handleSubmit using useCallback
//   const handleSubmit = useCallback(async () => {
//     console.log("Submit clicked");
//     if (!quiz || !quiz._id) {
//       console.error("Quiz not loaded properly");
//       return;
//     }
//     // Retrieve token from localStorage
//     const token = localStorage.getItem("token");
//     if (!token) {
//       console.error("No token found in localStorage");
//       return;
//     }
//     console.log("Quiz ID:", quiz._id);
//     console.log("Student Answers:", answers);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/api/quiz/submit`,
//         {
//           quizId: quiz._id,
//           answers,
//           timeTaken: quiz.duration - timeLeft,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       console.log("Submission response:", response.data);
//       setSubmitted(true);
//       setScore(response.data.score);
//     } catch (error) {
//       console.error(
//         "Error submitting quiz:",
//         error.response ? error.response.data : error.message
//       );
//     }
//   }, [quiz, answers, timeLeft]); // Add dependencies for useCallback

//   // Countdown timer effect
//   useEffect(() => {
//     if (timeLeft > 0 && !submitted) {
//       const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
//       return () => clearTimeout(timer);
//     }
//     // Auto-submit when time runs out
//     if (timeLeft === 0 && quiz && !submitted) {
//       handleSubmit();
//     }
//   }, [timeLeft, quiz, submitted, handleSubmit]); // Add handleSubmit to dependencies

//   const handleAnswerChange = (questionId, value) => {
//     setAnswers((prev) => ({ ...prev, [questionId]: value }));
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (loading) {
//     return <Typography>Loading quiz...</Typography>;
//   }
//   if (noQuiz) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "60vh", // takes most of the screen
//           textAlign: "center",
//         }}
//       >
//         <Typography variant="h6" color="textSecondary">
//           No quiz available at this time. Please check back later.
//         </Typography>
//       </div>
//     );
//   }

//   if (!quiz) {
//     return <Typography>Unexpected error. Could not load quiz.</Typography>;
//   }

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f5f7fa, #c3cfe2)", // Gradient background
//         py: 4,
//       }}
//     >
//       <Container maxWidth="md">
//         <Card
//           sx={{
//             bgcolor: "background.paper",
//             borderRadius: 2,
//             boxShadow: 3,
//             background: "linear-gradient(145deg, #ffffff, #f0f0f0)", // Gradient card background
//             transition: "transform 0.3s, box-shadow 0.3s",
//             "&:hover": {
//               transform: "scale(1.02)",
//               boxShadow: 6,
//             },
//           }}
//         >
//           <CardContent>
//             <Typography
//               variant="h4"
//               gutterBottom
//               sx={{ fontWeight: "bold", color: "primary.main" }}
//             >
//               {quiz.title}
//             </Typography>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
//               <TimerIcon sx={{ color: "primary.main" }} />
//               <Typography variant="subtitle1">
//                 Time left: {timeLeft} seconds
//               </Typography>
//             </Box>
//             {quiz.questions.map((q) => (
//               <Card
//                 key={q._id}
//                 sx={{
//                   mt: 2,
//                   mb: 2,
//                   bgcolor: "background.paper",
//                   borderRadius: 2,
//                   boxShadow: 2,
//                   background: "linear-gradient(145deg, #ffffff, #f0f0f0)", // Gradient card background
//                   transition: "transform 0.3s, box-shadow 0.3s",
//                   "&:hover": {
//                     transform: "scale(1.02)",
//                     boxShadow: 4,
//                   },
//                 }}
//               >
//                 <CardContent>
//                   <FormControl component="fieldset" fullWidth>
//                     <FormLabel
//                       component="legend"
//                       sx={{ fontWeight: "bold", mb: 1 }}
//                     >
//                       {q.question}
//                     </FormLabel>
//                     <RadioGroup
//                       name={q._id}
//                       value={answers[q._id] || ""}
//                       onChange={(e) =>
//                         handleAnswerChange(q._id, e.target.value)
//                       }
//                     >
//                       {q.options.map((option, idx) => (
//                         <FormControlLabel
//                           key={idx}
//                           value={option}
//                           control={<Radio />}
//                           label={option}
//                           sx={{ mb: 1 }}
//                         />
//                       ))}
//                     </RadioGroup>
//                   </FormControl>
//                 </CardContent>
//               </Card>
//             ))}
//             {!submitted ? (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleSubmit}
//                 fullWidth
//                 sx={{ mt: 3, fontWeight: "bold" }}
//               >
//                 Submit Quiz
//               </Button>
//             ) : (
//               <Typography
//                 variant="h5"
//                 sx={{ mt: 3, textAlign: "center", color: "primary.main" }}
//               >
//                 Your Score: {score}
//               </Typography>
//             )}
//             <Button
//               variant="outlined"
//               color="secondary"
//               fullWidth
//               sx={{ mt: 2, fontWeight: "bold" }}
//               onClick={() => navigate("/quiz/leaderboard")}
//             >
//               View Leaderboard
//             </Button>
//           </CardContent>
//         </Card>
//       </Container>
//     </Box>
//   );
// };

// export default Quiz;


import React, { useState, useEffect, useCallback } from "react"; // Add useCallback
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const Quiz = () => {
  const [quiz, setQuiz] = useState(null);
  const [answers, setAnswers] = useState({});
  const [timeLeft, setTimeLeft] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [noQuiz, setNoQuiz] = useState(false);

  const navigate = useNavigate();

  const student = localStorage.getItem("token");
  const decoded = jwtDecode(student);
  console.log(decoded);

  // Fetch quiz data from backend on mount
  useEffect(() => {
    const department = decoded.user.department;
    const subjects = decoded.user.subjects || [];

    if (!department || subjects.length === 0) {
      console.error("Missing department or subjects for student");
      return;
    }
    const fetchQuiz = async () => {
      setLoading(true);
      setNoQuiz(false);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/quiz`,
          {
            params: {
              department,
              subjects: subjects,
            },
          }
        );

        console.log("Fetched quiz:", response.data);
        setQuiz(response.data);
        setTimeLeft(response.data.duration);
      } catch (error) {
        console.error("Error fetching quiz:", error);
        if (error.response && error.response.status === 404) {
          setNoQuiz(true);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchQuiz();
  }, []);

  // Memoize handleSubmit using useCallback
  const handleSubmit = useCallback(async () => {
    console.log("Submit clicked");
    if (!quiz || !quiz._id) {
      console.error("Quiz not loaded properly");
      return;
    }
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found in localStorage");
      return;
    }
    console.log("Quiz ID:", quiz._id);
    console.log("Student Answers:", answers);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/quiz/submit`,
        {
          quizId: quiz._id,
          answers,
          timeTaken: quiz.duration - timeLeft,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Submission response:", response.data);
      setSubmitted(true);
      setScore(response.data.score);
    } catch (error) {
      console.error(
        "Error submitting quiz:",
        error.response ? error.response.data : error.message
      );
    }
  }, [quiz, answers, timeLeft]);

  // Countdown timer effect
  useEffect(() => {
    if (timeLeft > 0 && !submitted) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
    if (timeLeft === 0 && quiz && !submitted) {
      handleSubmit();
    }
  }, [timeLeft, quiz, submitted, handleSubmit]);

  const handleAnswerChange = (questionId, value) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getTimeColor = () => {
    if (timeLeft <= 30) return '#ef4444';
    if (timeLeft <= 60) return '#f97316';
    return '#10b981';
  };

  if (loading) {
    return (
      <div className="quiz-container loading-state">
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
          
          .quiz-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            position: relative;
            overflow: hidden;
            padding: 2rem 1rem;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          }

          .loading-state {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .loading-content {
            text-align: center;
            color: white;
          }

          .loading-spinner {
            width: 64px;
            height: 64px;
            border: 4px solid rgba(255, 255, 255, 0.3);
            border-top: 4px solid white;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 2rem;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .loading-text {
            font-size: 1.2rem;
            font-weight: 600;
          }
        `}</style>
        <div className="loading-content">
          <div className="loading-spinner"></div>
          <div className="loading-text">Loading Quiz...</div>
        </div>
      </div>
    );
  }

  if (noQuiz) {
    return (
      <div className="quiz-container no-quiz-state">
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
          
          .quiz-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            position: relative;
            overflow: hidden;
            padding: 2rem 1rem;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          }

          .no-quiz-state {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .no-quiz-content {
            text-align: center;
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(20px);
            border-radius: 24px;
            padding: 4rem 3rem;
            border: 1px solid rgba(255, 255, 255, 0.2);
            box-shadow: 0 20px 40px rgba(0,0,0,0.1);
            max-width: 500px;
          }

          .no-quiz-icon {
            width: 100px;
            height: 100px;
            background: rgba(102, 126, 234, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 2rem;
            color: #667eea;
          }

          .no-quiz-title {
            font-size: 1.5rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 1rem;
          }

          .no-quiz-description {
            color: #6b7280;
            font-size: 1rem;
            line-height: 1.6;
          }
        `}</style>
        <div className="no-quiz-content">
          <div className="no-quiz-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21A7,7 0 0,1 14,26H10A7,7 0 0,1 3,19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2Z"/>
            </svg>
          </div>
          <div className="no-quiz-title">No Quiz Available</div>
          <div className="no-quiz-description">
            There's no quiz available at this time. Please check back later or contact your instructor for more information.
          </div>
        </div>
      </div>
    );
  }

  if (!quiz) {
    return (
      <div className="quiz-container error-state">
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
          
          .quiz-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            position: relative;
            overflow: hidden;
            padding: 2rem 1rem;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          }

          .error-state {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .error-content {
            text-align: center;
            color: white;
            font-size: 1.2rem;
          }
        `}</style>
        <div className="error-content">
          Unexpected error. Could not load quiz.
        </div>
      </div>
    );
  }

  return (
    <div className="quiz-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .quiz-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .quiz-container::before {
          content: '';
          position: absolute;
          top: 15%;
          right: 10%;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 4s ease-in-out infinite;
        }

        .quiz-container::after {
          content: '';
          position: absolute;
          bottom: 20%;
          left: 12%;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 3.5s ease-in-out infinite;
          animation-delay: 1.8s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(8deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.8; }
          50% { opacity: 1; }
        }

        .pulse-element {
          position: absolute;
          top: 35%;
          right: 30%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.06);
          animation: pulse 3s ease-in-out infinite;
        }

        .quiz-wrapper {
          max-width: 900px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .header-section {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(10px);
        }

        .main-title {
          font-size: clamp(2.2rem, 4vw, 3rem);
          font-weight: 900;
          color: white;
          margin-bottom: 0.5rem;
          text-shadow: 0 4px 20px rgba(0,0,0,0.3);
          animation: slideIn 0.8s ease-out;
        }

        .gradient-text {
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .quiz-main-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: slideIn 0.6s ease-out 0.4s both;
          position: relative;
          overflow: hidden;
        }

        .quiz-main-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
          border-radius: 24px 24px 0 0;
        }

        .quiz-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 3rem;
          gap: 2rem;
        }

        .quiz-title-section {
          flex: 1;
        }

        .quiz-title {
          font-size: 1.8rem;
          font-weight: 800;
          color: #1f2937;
          margin-bottom: 0.5rem;
        }

        .quiz-subtitle {
          color: #6b7280;
          font-size: 1rem;
        }

        .timer-section {
          background: ${getTimeColor()};
          color: white;
          padding: 1.5rem;
          border-radius: 16px;
          text-align: center;
          min-width: 180px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
          animation: pulse 2s ease-in-out infinite;
        }

        .timer-icon {
          width: 32px;
          height: 32px;
          margin: 0 auto 0.5rem;
        }

        .timer-label {
          font-size: 0.9rem;
          opacity: 0.9;
          margin-bottom: 0.25rem;
        }

        .timer-value {
          font-size: 1.5rem;
          font-weight: 800;
        }

        .questions-container {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .question-card {
          background: white;
          border-radius: 20px;
          padding: 2.5rem;
          border: 2px solid rgba(229, 231, 235, 0.5);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          position: relative;
        }

        .question-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
          border-color: rgba(102, 126, 234, 0.3);
        }

        .question-number {
          position: absolute;
          top: -12px;
          left: 2rem;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 12px;
          font-size: 0.9rem;
          font-weight: 700;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .question-text {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 2rem;
          line-height: 1.5;
          padding-top: 0.5rem;
        }

        .options-container {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .option-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1.25rem;
          background: rgba(102, 126, 234, 0.02);
          border: 2px solid rgba(229, 231, 235, 0.5);
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }

        .option-item:hover {
          background: rgba(102, 126, 234, 0.05);
          border-color: rgba(102, 126, 234, 0.3);
        }

        .option-item.selected {
          background: rgba(102, 126, 234, 0.1);
          border-color: #667eea;
          box-shadow: 0 0 0 1px #667eea;
        }

        .option-radio {
          width: 20px;
          height: 20px;
          border: 2px solid #d1d5db;
          border-radius: 50%;
          position: relative;
          flex-shrink: 0;
          transition: all 0.2s ease;
        }

        .option-item.selected .option-radio {
          border-color: #667eea;
        }

        .option-item.selected .option-radio::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 10px;
          height: 10px;
          background: #667eea;
          border-radius: 50%;
        }

        .option-text {
          font-size: 1rem;
          color: #374151;
          font-weight: 500;
          flex: 1;
        }

        .quiz-actions {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .submit-btn, .leaderboard-btn {
          padding: 1.25rem 2rem;
          border: none;
          border-radius: 16px;
          font-size: 1.1rem;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;
          font-family: inherit;
          flex: 1;
          min-width: 200px;
        }

        .submit-btn {
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          color: white;
          box-shadow: 0 6px 25px rgba(16, 185, 129, 0.4);
        }

        .submit-btn:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(16, 185, 129, 0.5);
        }

        .leaderboard-btn {
          background: rgba(255, 255, 255, 0.9);
          color: #667eea;
          border: 2px solid rgba(102, 126, 234, 0.3);
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
        }

        .leaderboard-btn:hover {
          transform: translateY(-2px);
          background: white;
          border-color: #667eea;
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
        }

        .score-display {
          text-align: center;
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          color: white;
          padding: 2rem;
          border-radius: 20px;
          margin-bottom: 2rem;
          box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
        }

        .score-icon {
          width: 60px;
          height: 60px;
          margin: 0 auto 1rem;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .score-label {
          font-size: 1rem;
          opacity: 0.9;
          margin-bottom: 0.5rem;
        }

        .score-value {
          font-size: 2.5rem;
          font-weight: 900;
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .quiz-container {
            padding: 1rem 0.5rem;
          }
          
          .quiz-main-card {
            padding: 2rem 1.5rem;
          }

          .quiz-header {
            flex-direction: column;
            gap: 1.5rem;
          }

          .timer-section {
            align-self: stretch;
          }

          .question-card {
            padding: 2rem 1.5rem;
          }

          .quiz-actions {
            flex-direction: column;
          }

          .submit-btn, .leaderboard-btn {
            min-width: auto;
          }
        }

        @media (max-width: 480px) {
          .main-title {
            font-size: 2rem;
          }
          
          .quiz-main-card {
            padding: 1.5rem 1rem;
          }

          .question-card {
            padding: 1.5rem 1rem;
          }

          .option-item {
            padding: 1rem;
          }
        }
      `}</style>

      <div className="pulse-element"></div>
      
      <div className="quiz-wrapper">
        {/* Header Section */}
        <div className="header-section">
          <div className="header-chip">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21A7,7 0 0,1 14,26H10A7,7 0 0,1 3,19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2Z"/>
            </svg>
            Quiz Portal
          </div>
          
          <h1 className="main-title">
            <span className="gradient-text">Quiz</span> Time
          </h1>
        </div>

        {/* Main Quiz Card */}
        <div className="quiz-main-card">
          <div className="quiz-header">
            <div className="quiz-title-section">
              <div className="quiz-title">{quiz.title}</div>
              <div className="quiz-subtitle">Answer all questions before time runs out</div>
            </div>
            <div className="timer-section">
              <svg className="timer-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"/>
              </svg>
              <div className="timer-label">Time Remaining</div>
              <div className="timer-value">{formatTime(timeLeft)}</div>
            </div>
          </div>

          {!submitted ? (
            <>
              <div className="questions-container">
                {quiz.questions.map((q, index) => (
                  <div key={q._id} className="question-card">
                    <div className="question-number">Q{index + 1}</div>
                    <div className="question-text">{q.question}</div>
                    <div className="options-container">
                      {q.options.map((option, idx) => (
                        <label
                          key={idx}
                          className={`option-item ${answers[q._id] === option ? 'selected' : ''}`}
                        >
                          <div className="option-radio"></div>
                          <div className="option-text">{option}</div>
                          <input
                            type="radio"
                            name={q._id}
                            value={option}
                            checked={answers[q._id] === option}
                            onChange={(e) => handleAnswerChange(q._id, e.target.value)}
                            style={{ display: 'none' }}
                          />
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="quiz-actions">
                <button className="submit-btn" onClick={handleSubmit}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M10,17L18,9L16.59,7.58L10,14.17L7.41,11.59L6,13L10,17Z"/>
                  </svg>
                  Submit Quiz
                </button>
                <button
                  className="leaderboard-btn"
                  onClick={() => navigate("/quiz/leaderboard")}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M15.5,5A1.5,1.5 0 0,0 14,6.5A1.5,1.5 0 0,0 15.5,8A1.5,1.5 0 0,0 17,6.5A1.5,1.5 0 0,0 15.5,5M12,4A4,4 0 0,1 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M21,14V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V14A2,2 0 0,1 5,12H19A2,2 0 0,1 21,14M19,16H17V20H19V16M15,16H13V20H15V16M11,16H9V20H11V16M7,16H5V20H7V16Z"/>
                  </svg>
                  View Leaderboard
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="score-display">
                <div className="score-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M10,17L18,9L16.59,7.58L10,14.17L7.41,11.59L6,13L10,17Z"/>
                  </svg>
                </div>
                <div className="score-label">Your Score</div>
                <div className="score-value">{score}</div>
              </div>
              
              <div className="quiz-actions">
                <button
                  className="leaderboard-btn"
                  onClick={() => navigate("/quiz/leaderboard")}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M15.5,5A1.5,1.5 0 0,0 14,6.5A1.5,1.5 0 0,0 15.5,8A1.5,1.5 0 0,0 17,6.5A1.5,1.5 0 0,0 15.5,5M12,4A4,4 0 0,1 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M21,14V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V14A2,2 0 0,1 5,12H19A2,2 0 0,1 21,14M19,16H17V20H19V16M15,16H13V20H15V16M11,16H9V20H11V16M7,16H5V20H7V16Z"/>
                  </svg>
                  View Leaderboard
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Quiz;